<ng-container>
  @if(!isFromVault) {
  <div [class]="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected ? 'mb-[42px]' : 'mb-[12px]'">
    <div class="m-0 flex items-start flex-col gap-[8px]">
      <span
        class="text-[#53565B] text-xl font-semibold font-open-sans"
        *ngIf="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
      >
        Do you want to add <span class="text-[#25508E] font-bold">Admins</span> to
        <span class="text-[#25508E] font-bold">{{ userObject.nick_name ?? personalVaultName ?? stateObject.name | titlecase }}’s Vault</span>?
      </span>

      <span
        class="text-[#53565B] text-xl font-semibold font-open-sans"
        *ngIf="this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
      >
        Manage <span class="text-[#25508E] font-bold">Admins</span> for
        <span class="text-[#25508E] font-bold">{{ userObject.nick_name ?? personalVaultName ?? stateObject.name | titlecase }}’s Vault</span>
      </span>

      <span
        class="text-[#18191C] font-open-sans font-normal text-sm"
        *ngIf="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
      >
        Admins are people who might help manage or update items within the vault. You can manage admin permissions in future steps as necessary.
      </span>
    </div>
  </div>

  <div
    class="flex flex-col gap-5 w-[291px]"
    *ngIf="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected && !isVaultSetupLoading"
  >
    <div
      [class]="option?.isSelected ? 'app__discovery-option-form-selected ' : 'app__discovery-option-form'"
      *ngFor="let option of options"
      (click)="handleSubFlow(option.value, level)"
    >
      <span class="text-[20px] m-0 font-open-sans text-[#53565B] font-semibold leading-[22.5px]">
        {{ option.value }}
      </span>
    </div>
  </div>
  }

  <div *ngIf="isVaultSetupLoading && !isFromVault">
    <vault-setup-loading [text]="'One moment while we check for existing admins'"></vault-setup-loading>
  </div>

  <div class="w-full" *ngIf="!isVaultSetupLoading">
    <!-- Search Connection -->

    <div class="form-group form-main form-group-overrides w-full mb-0">
      <div class="div-group w-full" style="display: flex; justify-content: center; align-items: center">
        <div
          class="w-full"
          *ngIf="allUserConnections && allUserConnections.length > 0 && this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
        >
          <manage-users
            [data]="allUserConnections"
            placeHolder="Search Connections"
            (selectConnectedUser)="selectConnectedUser($event)"
            [selectedUsers]="nonProfessionalUsers"
            [isBalanceSheetMember]="true"
            [isShowFooter]="true"
            [isInputFullWidth]="true"
          ></manage-users>
        </div>
      </div>
    </div>

    <!-- No Admin to Show -->
    <div
      class="width-100per"
      [ngClass]="{ 'mt-[4px]': isFromVault, 'mt-[30px]': !isFromVault }"
      *ngIf="!nonProfessionalUsers?.length && this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
    >
      <div class="flex-center"><img src="assets/images/admin/noAdminShow.svg" /></div>
      <span class="flex-center font-sans font-semibold text-lg" [ngClass]="{ 'mt-[24px]': isFromVault, 'mt-8': !isFromVault }" style="color: #53565b"
        >No&nbsp;<span class="font-bold" style="color: #25508e">Admins</span>&nbsp;to show</span
      >
    </div>

    <!-- Admin Data To show -->

    <div class="width-100per d-flex text-sm font-sans font-semibold text-[#1E1E20]" style="margin-top: 12px" *ngIf="nonProfessionalUsers?.length">
      Admin<span *ngIf="nonProfessionalUsers?.length > 1">s</span>&nbsp;<span class="text-[#25508E] font-bold"
        >({{ nonProfessionalUsers?.length }})</span
      >
    </div>

    <div class="member-infos mt-3 width-100per" *ngIf="nonProfessionalUsers?.length">
      <div
        class="member-infos--left w-100per"
        [ngStyle]="{
          'max-height': switchFromUser ? (isFromVault ? '250px' : 'calc(100vh - 486px)') : isFromVault ? '250px' : 'calc(100vh - 434px)',
          'max-width':
            isFromVault && nonProfessionalUsers?.length > 2 ? 'calc(100% + 20px)' : isFromVault && nonProfessionalUsers?.length < 3 ? '100%' : ''
        }"
      >
        <div
          *ngFor="let user of nonProfessionalUsers; let i = index"
          class="flex fl-al-center fl-justify-between w-100per mobile-member-item-view member-infos--add"
          [ngStyle]="{
            'max-width':
              nonProfessionalUsers?.length > 2 && isFromVault ? 'calc(100% - 16px)' : isFromVault && nonProfessionalUsers?.length < 3 ? '100% ' : '',
            'margin-top': i == 0 ? '0px' : '16px'
          }"
        >
          <div class="selected-client-wrapper">
            <div class="flex fl-al-center mobile-view-wrapper" *ngIf="user?.first_name && user?.last_name && !user?.name">
              <div *ngIf="user?.isGroup">
                <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
              </div>
              <ngx-avatars
                *ngIf="!user?.isGroup"
                size="50"
                src="{{ user?.user_profile_image_url }}"
                name="{{ user.nick_name ?? user?.first_name + ' ' + user?.last_name }}"
                [round]="true"
                initialsSize="2"
              ></ngx-avatars>
              <div class="flex fl-col gap-[2px] ml-[8px]">
                <span class="new-member-infos--name">{{ user.nick_name ?? user?.first_name + ' ' + user?.last_name }}</span>
                <span class="new-member-infos--subname">{{ user?.relationship_name }}</span>
              </div>
            </div>

            <div class="flex fl-al-center mobile-view-wrapper" *ngIf="user?.name && !user?.first_name">
              <div *ngIf="user?.isGroup">
                <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
              </div>
              <ngx-avatars
                *ngIf="!user?.isGroup"
                size="50"
                src="{{ user?.user_profile_image_url }}"
                name="{{ user?.name }}"
                [round]="true"
                initialsSize="2"
              ></ngx-avatars>
              <div class="flex fl-col gap-[2px] ml-[8px]">
                <span class="new-member-infos--name">{{ user?.name }}</span>
                <span class="new-member-infos--subname">{{ user?.relationship_name }}</span>
              </div>
            </div>

            <div class="flex fl-al-center" *ngIf="user?.user_first_middle_name && user?.user_last_name">
              <div *ngIf="user?.isGroup">
                <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
              </div>
              <ngx-avatars
                *ngIf="!user?.isGroup"
                size="50"
                src="{{ user?.user_profile_image_url }}"
                name="{{ user?.user_first_middle_name + ' ' + user?.user_last_name }}"
                [round]="true"
                initialsSize="2"
              ></ngx-avatars>
              <div class="flex fl-col gap-[2px] ml-[8px]">
                <span class="new-member-infos--name">{{ user?.user_first_middle_name + ' ' + user?.user_last_name }}</span>
                <span class="new-member-infos--subname">{{ user?.relationship_name }}</span>
              </div>
            </div>

            <div class="flex fl-al-center mobile-view-wrapper" *ngIf="user?.memberUser?.name">
              <div *ngIf="user?.memberUser?.isGroup">
                <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
              </div>
              <ngx-avatars
                *ngIf="!user?.memberUser?.isGroup"
                size="50"
                src="{{ user?.memberUser?.user_profile_image_url }}"
                name="{{ user?.memberUser?.name }}"
                [round]="true"
                initialsSize="2"
              ></ngx-avatars>

              <div class="flex fl-col gap-[2px] ml-[8px]">
                <span class="new-member-infos--name">{{ user?.memberUser?.name }}</span>
                <span class="new-member-infos--subname">{{ user?.memberUser?.relationship_name }}</span>
              </div>
            </div>

            <!-- <div *ngIf="user?.connection_status == 'pending'" class="relatinoship-title text-truncate">
                <mat-icon
                  style="font-size: 16px; height: 16px; width: 16px; margin-right: 4px;margin-bottom: 0px; color: unset">check_circle</mat-icon>
                {{ user?.from_user_id == currentUser.id ? ' Network request sent ' : ' Network request received ' }}
              </div>
              <div *ngIf="user?.connection_status == 'invited'" class="relatinoship-title text-truncate">
                <mat-icon
                  style="font-size: 16px;height: 16px; width: 16px; margin-right: 4px;margin-bottom: 0px; color: unset">check_circle</mat-icon>
                Invite sent
              </div> -->
          </div>

          <div class="member-infos--trash flex-center pointer">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon class="menu">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
              <button mat-menu-item (click)="deleteAdmin(user, true)">
                <mat-icon height="20px" style="color: #eb5757; margin-right: 8px">delete</mat-icon>
                <span class="text-xs font-semibold" style="color: #eb5757">Remove</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
